import React from 'react';

import styled from '@emotion/styled';

import Icons from '../../../themes/icons';

type Props = {
  tag?: string;
};

export const TikTokOfferRequirement: React.FC<Props> = ({ tag }) => {
  return (
    <Container>
      <Icons.TiktokIcon />
      <InfoContainer>
        <Title>Post 1 TikTok video</Title>
        <Description>{tag ? `tag @${tag}` : 'No Tag'}</Description>
      </InfoContainer>
    </Container>
  );
};

const Container = styled.div`
  border-radius: 9px;
  border: 1px solid #e9d4ff;
  background-image: linear-gradient(90deg, #faf5ff 0%, #fdf2f8 100%);
  display: flex;
  align-items: center;
  padding: 20px;
  gap: 20px;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.p`
  font-weight: 600;
  font-size: 15px;
  color: #111;
  font-family: Poppins;
  margin: 0;
  padding: 0;
`;

const Description = styled.p`
  font-size: 15px;
  font-weight: 400;
  color: #111;
  font-family: Poppins;
  margin: 0;
  padding: 0;
`;
